import React, { useEffect } from 'react';
import styles from './AuthModal.module.css';
import LoginForm from './../LoginForm/LoginForm';
import ForgotPassword from './../ForgotPassword/ForgotPassword';
import { HiXMark } from 'react-icons/hi2'; // Heroicons X mark
import Button from '../ui/Button';

const AuthModal = ({ isOpen, onClose, showForgot, onshowForgot, settings }) => {
  useEffect(() => {
    const handleKeyDown = e => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [onClose]);

  if (!isOpen) return null;

  return (
    <div className={styles.backdrop} onClick={onClose}>
      <div className={styles.modal}
        onClick={e => e.stopPropagation()}
        role="dialog"
        aria-modal="true">
        <Button variant="ghost" className={styles.closeButton} onClick={onClose}>
           <HiXMark className={styles.closeIcon} />
        </Button>
        {showForgot ? <ForgotPassword modal={true} onLoginForm={() => {onshowForgot(false)}} onClose={onClose} /> : <LoginForm settings={settings} modal={true} onForgotPassword={() => {onshowForgot(true)}}  onClose={onClose} />}
      </div>
    </div>
  );
};

export default AuthModal;
